// extracted by mini-css-extract-plugin
export default {"siteloader":"siteloader_siteloader__mVRGM","main":"siteloader_main__qfD27","center":"siteloader_center__b8uLq"};